const mutations = {
    setMockCompany(state,payload){
        state.MockCompanyID = payload
    },
    setCompaniesForMocker(state,payload){
        state.companies = payload
    },
    setExpandAll(state, payload) {
        state.expandAll = payload
    }
}

export default mutations
